const MuiListItemButton = {
  defaultProps: {
    disableRipple: true,
  },
};

export default MuiListItemButton;
